module.exports = __webpack_public_path__ + "img/author.3d16aea3.png";